import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=878223ca&scoped=true"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=ts"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=ts"
import style0 from "./EditEmailTemplate.vue?vue&type=style&index=0&id=878223ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878223ca",
  null
  
)

export default component.exports